import React from 'react'
import { Element, baseChildNodes, baseNormalizer } from './ElementPlugin'

const childTypes = ['elementTitle', 'multiSelectAnswer']

const MultiSelectPlugin = () => {
  return {
    schema: {
      blocks: {
        multiSelect: {
          parent: { object: 'document' },
          nodes: baseChildNodes.concat([
            {
              match: {
                type: 'multiSelectAnswer'
              },
              min: 0
            }
          ]),
          normalize: (editor, { code, node, child, index }) => {
            baseNormalizer(editor, { code, node, child, index })

            switch (code) {
              case 'child_max_invalid':
                if (index > 1) {
                  editor.setNodeByKey(child.key, 'multiSelectAnswer')
                }
                break
              default:
                break
            }
          }
        }
      }
    },
    onConstruct(editor, next) {
      editor.registerElement('multiSelect', {
        menu: {
          command: 'convertToMultiSelect',
          label: 'Multi Select',
          icon: 'ion-android-checkbox',
          type: 'Multi'
        },
        childTypes: childTypes
      })
      return next()
    },
    commands: {
      convertToMultiSelect(editor, node, data = {}) {
        editor.convertToElement(node, 'multiSelect', childTypes, data)
      }
    },
    renderNode(props, editor, next) {
      switch (props.node.type) {
        case 'multiSelect':
          return <MultiSelect {...props} />
        case 'multiSelectAnswer':
          return <Answer {...props} />
        default:
          return next()
      }
    }
  }
}

const MultiSelect = props => (
  <Element
    className={'element-multi-select'}
    iconName={'ion-android-checkbox'}
    {...props}
  >
    {props.children}
  </Element>
)

const CheckboxIcon = props => (
  <Element.AnswerControl className={'ion-android-checkbox-outline-blank'} />
)

const Answer = props => (
  <Element.AnswerRow>
    <CheckboxIcon />
    <span>{props.children}</span>
    {props.node.data.get('openEnded') ? (
      <input type="text" disabled="true" />
    ) : null}
  </Element.AnswerRow>
)

export default MultiSelectPlugin



// WEBPACK FOOTER //
// ./src/components/Editor/plugins/MultiSelectPlugin.js